import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import * as config from 'config'

class Captcha extends React.Component {
	reset() {
		return config.enableCaptcha && this.captcha.reset()
	}

	execute() {
		if (config.enableCaptcha) this.captcha.execute()
		else this.props.onChange(true)
	}

	render() {
		return (
			config.enableCaptcha && (
				<ReCAPTCHA
					size="invisible"
					style={this.props.style}
					onChange={this.props.onChange}
					sitekey={config.recaptchaSiteKey}
					ref={element => {
						this.captcha = element
					}}
				/>
			)
		)
	}
}

export default Captcha
